/* istanbul ignore file */
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import React from 'react';
import { Collapsible, HtmlField } from 'framework/ui/field';
import FeedbackFooter from 'domain/people/employee/Timeline/feedback/shared/layout/FeedbackFooter';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import TimelineSentFeedbackHeader from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/TimelineSentFeedbackHeader';
import FeedbackOnBehalf from 'domain/people/employee/Timeline/feedback/shared/layout/FeedbackOnBehalf';
import { useShowContext } from 'framework/show';

const SentFeedbackTimelineRecordLayout = ({ ...props }) => {
  const { data: entity } = useShowContext();
  const feedbackText = entity.getValueBySource('feedbackText');

  return (
    <BaseTimelineRecordLayout
      permissionToCheck={null}
      actionName=""
      timelineType={TimelineType.FEEDBACK}
      buttons={[]}
      fields={
        feedbackText ? (
          <Collapsible>
            <HtmlField source="feedbackText" label="" />
          </Collapsible>
        ) : null
      }
      timelineHeader={rest => (
        <TimelineSentFeedbackHeader {...rest} actionName={behalfProps => <FeedbackOnBehalf {...behalfProps} />} />
      )}
      timelineActions={() => null}
      timelineFooter={rest => <FeedbackFooter {...rest} />}
      {...props}
    />
  );
};

export default SentFeedbackTimelineRecordLayout;
